import PropTypes from 'prop-types';

import { EDITOR_VIDEO } from '../constants';
import { getTitle } from '../utils/document';

import { Helmet } from 'react-helmet';
import './InlineDemoEditorPage.scss';

/**
 * Local dev only: this page is never rendered on staging or prod.
 *
 * Deployed builds serve `/demo-editor-inline` from the static
 * `src/demo-editor-inline.html` entry (via an Amplify rewrite), so changes here
 * won't ship. Edit `src/demo-editor-inline.html` instead. This route only
 * renders locally because `npm start` serves `index.html` for every path.
 */
const InlineDemoEditorPage = () => {
  const { width, height } = EDITOR_VIDEO;
  // Fit the iframe inside the viewport while keeping the video's aspect ratio
  const style = {
    aspectRatio: `${width} / ${height}`,
    width: `min(100vw, calc(100vh * ${width} / ${height}))`,
  };

  return (
    <div className="inline-demo">
      <Helmet>
        <title>{getTitle('Editor Demo Video')}</title>
      </Helmet>
      <div className="inline-demo--inner">
        <iframe
          src={`${EDITOR_VIDEO.youtube}&autoplay=1`}
          width={width}
          height={height}
          style={style}
          title="Editor Demo Video"
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    </div>
  );
};

InlineDemoEditorPage.propTypes = {
  history: PropTypes.object.isRequired, // via react-router
};

// export default connectGTM(InlineDemoEditorPage);

export default InlineDemoEditorPage;
